/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Art12Inputs */

const en__field__enum_teachingsubjectinterest_subject_art12 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Art12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

const de__field__enum_teachingsubjectinterest_subject_art12 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Art12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst`)
};

/**
* | output |
* | --- |
* | "Art" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Art12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_art12 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Art12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Art12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_art12(inputs)
	return de__field__enum_teachingsubjectinterest_subject_art12(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_art12 as "_field__enum_teachingSubjectInterest_SUBJECT_ART" }